var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dollar-fill",
    fill: "#9896c9",
    d: "M255.9,156.6h-27.2c-7.8,0-14.1-6.3-14.1-14.1s6.3-14.1,14.1-14.1h27.2C249,72,200.8,28.2,142.6,28.2 S36.3,72,29.3,128.4h31.5c7.8,0,14.1,6.3,14.1,14.1s-6.3,14.1-14.1,14.1H29.3c7,56.4,55.1,100.2,113.3,100.2S249,213,255.9,156.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "euro-fill",
    fill: "#9896c9",
    d: "M479.7,365.5c0-63-51.3-114.3-114.3-114.3s-114.3,51.3-114.3,114.3s51.3,114.3,114.3,114.3 S479.7,428.5,479.7,365.5z M390.1,351.4c7.8,0,14.1,6.3,14.1,14.1c0,7.8-6.3,14.1-14.1,14.1h-64.4c6.5,29.6,32.9,51.9,64.4,51.9 c7.8,0,14.1,6.3,14.1,14.1c0,7.8-6.3,14.1-14.1,14.1c-47.1,0-86.2-34.8-93-80.1h-12.9c-7.8,0-14.1-6.3-14.1-14.1 c0-7.8,6.3-14.1,14.1-14.1h12.9c6.8-45.3,45.9-80.1,93-80.1c7.8,0,14.1,6.3,14.1,14.1c0,7.8-6.3,14.1-14.1,14.1 c-31.5,0-58,22.3-64.4,51.9H390.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M144.6,156.6h-0.1C144.1,156.7,144.5,156.7,144.6,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M140.6,128.4h0.1C141.1,128.4,140.7,128.4,140.6,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dollar",
    style: {
      fill: "#194F82"
    },
    d: "M140.7,128.5c-0.2,0-0.2,0-0.1,0c-11.3-1-20.2-10.6-20.2-22.1c0-12.3,10-22.2,22.2-22.2 c12.3,0,22.2,10,22.2,22.2c0,7.8,6.3,14.1,14.1,14.1s14.1-6.3,14.1-14.1c0-22.9-15.4-42.3-36.3-48.4V48c0-7.8-6.3-14.1-14.1-14.1 s-14.1,6.3-14.1,14.1v10c-21,6.1-36.3,25.5-36.3,48.4c0,27.8,24.5,50.3,52.3,50.3c0.2,0,0.2,0,0.1,0c11.3,1,20.2,10.6,20.2,22.1 c0,12.3-10,22.2-22.2,22.2c-12.3,0-22.2-10-22.2-22.2c0-7.8-6.3-14.1-14.1-14.1s-14.1,6.3-14.1,14.1c0,22.9,15.4,42.3,36.3,48.4v10 c0,7.8,6.3,14.1,14.1,14.1s14.1-6.3,14.1-14.1v-10c21-6.1,36.3-25.5,36.3-48.4C193.1,150.9,168.5,128.5,140.7,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "euroCircle",
    style: {
      fill: "#194F82"
    },
    d: "M365.4,223c-78.6,0-142.5,63.9-142.5,142.5S286.8,508,365.4,508s142.5-63.9,142.5-142.5 S444,223,365.4,223z M365.4,479.8c-63,0-114.3-51.3-114.3-114.3s51.3-114.3,114.3-114.3s114.3,51.3,114.3,114.3 S428.4,479.8,365.4,479.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "euro",
    style: {
      fill: "#194F82"
    },
    d: "M390.1,299.5c7.8,0,14.1-6.3,14.1-14.1c0-7.8-6.3-14.1-14.1-14.1c-47.1,0-86.2,34.8-93,80.1h-12.9 c-7.8,0-14.1,6.3-14.1,14.1c0,7.8,6.3,14.1,14.1,14.1h12.9c6.8,45.3,45.9,80.1,93,80.1c7.8,0,14.1-6.3,14.1-14.1 c0-7.8-6.3-14.1-14.1-14.1c-31.5,0-57.9-22.3-64.4-51.9h64.4c7.8,0,14.1-6.3,14.1-14.1c0-7.8-6.3-14.1-14.1-14.1h-64.4 C332.2,321.8,358.6,299.5,390.1,299.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "border",
    style: {
      fill: "#194F82"
    },
    d: "M465.8,190.3c-7.8,0-14.1-6.3-14.1-14.1v-84c0-20.2-16.5-36.7-36.7-36.7h-84 c-7.8,0-14.1-6.3-14.1-14.1s6.3-14.1,14.1-14.1h84c35.8,0,64.9,29.1,64.9,64.9v84C479.9,184,473.6,190.3,465.8,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "border",
    style: {
      fill: "#194F82"
    },
    d: "M177,480.8H93c-35.8,0-64.9-29.1-64.9-64.9v-84c0-7.8,6.3-14.1,14.1-14.1s14.1,6.3,14.1,14.1v84 c0,20.2,16.5,36.7,36.7,36.7h84c7.8,0,14.1,6.3,14.1,14.1C191.1,474.5,184.8,480.8,177,480.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dollarCircle",
    style: {
      fill: "#194F82"
    },
    d: "M142.6,0C64,0,0.1,63.9,0.1,142.5S64,285,142.6,285s142.5-63.9,142.5-142.5S221.2,0,142.6,0z  M142.6,256.8c-58.2,0-106.3-43.8-113.3-100.2h31.5c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1H29.3 C36.3,72,84.4,28.2,142.6,28.2S248.9,72,255.9,128.4h-27.2c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h27.2 C249,213,200.8,256.8,142.6,256.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyLogo);
export default __webpack_public_path__ + "static/media/currencyLogo.58e73dc1fa18d431541b5f0cb17f9c1f.svg";
export { ForwardRef as ReactComponent };